export default __webpack_public_path__ + "static/outlook-calendar-integration-7e5d5ef21b5a0b969ee2b1a4c870679f.mp4";